import { ref, onUnmounted } from "vue";

export default function useRecaptcha() {
  const recaptchaLoaded = ref(false);
  const recaptchaToken = ref(null);
  const recaptchaError = ref(null);
  let recaptchaScript = null;

  const loadRecaptcha = () => {
    recaptchaScript = document.createElement("script");
    recaptchaScript.src = `https://www.google.com/recaptcha/api.js?render=${
      import.meta.env.VUE_APP_RECAPTCHA_SITE_KEY
    }`;
    recaptchaScript.async = true;
    recaptchaScript.defer = true;
    document.head.appendChild(recaptchaScript);
    recaptchaScript.onload = () => {
      recaptchaLoaded.value = true;
    };
  };

  const executeRecaptcha = async (action) => {
    recaptchaError.value = null;
    if (!recaptchaLoaded.value) {
      // Wait for recaptcha to load if needed
      await new Promise((resolve) => {
        const checkLoaded = setInterval(() => {
          if (recaptchaLoaded.value) {
            clearInterval(checkLoaded);
            resolve();
          }
        }, 100);
      });
    }

    if (!window.grecaptcha) {
      recaptchaError.value = "reCAPTCHA not available";
      return null;
    }

    try {
      const token = await window.grecaptcha.execute(
        import.meta.env.VUE_APP_RECAPTCHA_SITE_KEY,
        { action }
      );
      recaptchaToken.value = token;
      return token;
    } catch (error) {
      console.error("reCAPTCHA error:", error);
      recaptchaError.value = "Verification failed";
      return null;
    }
  };

  const cleanup = () => {
    if (recaptchaScript && recaptchaScript.parentNode) {
      recaptchaScript.parentNode.removeChild(recaptchaScript);
    }
  };

  onUnmounted(() => {
    cleanup();
  });

  return {
    recaptchaLoaded,
    recaptchaToken,
    recaptchaError,
    loadRecaptcha,
    executeRecaptcha,
    cleanup,
  };
}
